var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarehouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.387,
    height: 26.001,
    viewBox: "0 0 29.387 26.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a77bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01aced"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "store",
    d: "M30.614,11.458l-2.026-6.25A1.014,1.014,0,0,0,27.575,4.5H5.288a1.014,1.014,0,0,0-1.013.708l-2.026,6.25a1.274,1.274,0,0,0,0,.333v6.25a1.028,1.028,0,0,0,1.013,1.042H4.275V29.5H6.3V19.082h6.078V29.5H28.588V19.082H29.6a1.028,1.028,0,0,0,1.013-1.042v-6.25a1.274,1.274,0,0,0,0-.333ZM26.562,27.415H14.405V19.082H26.562ZM28.588,17H24.536V12.833H22.51V17H17.444V12.833H15.418V17H10.353V12.833H8.327V17H4.275V11.958L6.017,6.583H26.845l1.742,5.375Z",
    transform: "translate(-1.738 -3.997)",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.844097e3f5f0cdc43c82cf14cba419ba.svg";
export { ForwardRef as ReactComponent };